import React from 'react';

export function dispatchSetProductBundlesList(bundles, oldBundlesCount) {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  dispatch({
    type: 'SET_PRODUCT_BUNDLES_LIST',
    payload: {
      bundles: [
        ...bundles.map((bundle) => ({
          bundleType: bundle.recommendationType,
          bundleExecution: bundle.bundleType
        })),
        ...Array.from(Array(oldBundlesCount).keys()).map(() => ({
          bundleType: 'static'
        }))
      ]
    }
  });
}

export default (BaseComponent) => {
  const dispatch = window.appState ? window.appState.dispatch : () => {};

  function dispatchAddToBasket(payload) {
    dispatch({
      type: 'BUNDLE_ADD_TO_BASKET',
      payload: {
        ...payload,
        trackFunctionArgs: 'bundleAddToBasket'
      }
    });
  }

  function onBundlesReveived(bundles, oldBundlesCount, userCreatedBundlesCount) {
    dispatchSetProductBundlesList(bundles, oldBundlesCount, userCreatedBundlesCount);
  }

  return (props) => (
    <BaseComponent
      onAddToBasket={dispatchAddToBasket}
      onBundlesReceived={onBundlesReveived}
      {...props}
    />
  );
};
